module.exports = __webpack_public_path__ + "static/media/alladin.ed8d1f59.mp3";